import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const get = axios.get
const post = axios.post
const api = '/api/membership/'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const response = await request
    return response.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error.response?.data ?? {
        message: 'Unable to connect to the server.',
      }
    )
  }
}

export const Memberships = createAsyncThunk('memberships', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}memberships`, params), thunkAPI)
)

export const StoreMember = createAsyncThunk('store-member', (data: FormData, thunkAPI) =>
  handleRequest(post(`${api}store`, data), thunkAPI)
)

export const EditMember = createAsyncThunk('edit', (id: string, thunkAPI) =>
  handleRequest(get(`${api}edit/${id}`), thunkAPI)
)

export const ViewMember = createAsyncThunk('view', (id: string, thunkAPI) =>
  handleRequest(get(`${api}view/${id}`), thunkAPI)
)

export const SwitchStatus = createAsyncThunk('switch-status', (id: string, thunkAPI) =>
  handleRequest(get(`${api}switch-status/${id}`), thunkAPI)
)

export const DestroyMember = createAsyncThunk('destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${api}destroy/${id}`), thunkAPI)
)

export const EmailMember = createAsyncThunk('email', (data: FormData, thunkAPI) =>
  handleRequest(post(`${api}email`, data), thunkAPI)
)

export const ChangeRecStat = createAsyncThunk('change-record-status', (data: FormData, thunkAPI) =>
  handleRequest(post(`${api}change-record-status`, data), thunkAPI)
)

type AdminState = {
  general: any
  notification: any
}

const initialState: AdminState = {
  general: [],
  notification: [],
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = adminSlice.actions
export default adminSlice.reducer
